"use strict";

import BaseModel from "dias/core/models/baseModel";

class Antragslisten extends BaseModel {
  constructor() {
    super("antragslisten");
  }
}

export default Antragslisten;
